<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm @submit.prevent="restore">
                  <h1>Restablecer contraseña</h1>
                  <p class="text-muted">Ingresa a tu cuenta</p>
                  <CInput
                    placeholder="Username"
                    autocomplete="username email"
                    v-model="form.email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CRow v-if="sended">
                    <CCol>
                      <CAlert color="info" dismissible>
                        <strong>Se envió un correo con las instrucciones para recuperar tu clave</strong>
                      </CAlert>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol col="5" class="text-left">
                      <CButton color="primary" class="px-8" type="submit">
                        <CSpinner v-if="loading" variant="grow" size="sm"/>
                         Enviar correo  
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <CCardBody class="banner">
                <img src="img/banner_inicio.jpg" width="100%" />
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { resetRequest } from '@/api/auth'


export default {
  data: () => ({
    user: {},
    form: {
      email: '',
    },
    loading: false,
    sended: false,
  }),
  methods: {
    async restore() {
      this.loading = true;
      await resetRequest(this.form).then(response => {
        this.sended = true;
        this.loading = false;
      }).catch(error => {
        this.loading = false;
      })
    },
    open() {
      this.$router.push({
        path: "login",
      });
    },
  },
  name: 'Login'
}
</script>
